const API_PORT = import.meta.env.VITE_API_PORT || "8000";

/**
 * API base URL (no trailing slash).
 * In the browser, uses the page hostname so LAN access (e.g. 172.16.x.x:5173 → :8000) works.
 * Set VITE_API_DYNAMIC=false to always use VITE_API_URL.
 */
export function getApiUrl() {
  const configured = import.meta.env.VITE_API_URL
    ? String(import.meta.env.VITE_API_URL).replace(/\/$/, "")
    : "";

  if (typeof window !== "undefined") {
    if (import.meta.env.VITE_API_DYNAMIC === "false" && configured) {
      return configured;
    }
    return `${window.location.protocol}//${window.location.hostname}:${API_PORT}/api`;
  }

  return configured || `http://localhost:${API_PORT}/api`;
}
